// TODO: to delete later , during Placement refactoring
export var ReceiptedPlacementGrouping;
(function (ReceiptedPlacementGrouping) {
    ReceiptedPlacementGrouping[ReceiptedPlacementGrouping["None"] = 0] = "None";
    ReceiptedPlacementGrouping[ReceiptedPlacementGrouping["Client"] = 1] = "Client";
})(ReceiptedPlacementGrouping || (ReceiptedPlacementGrouping = {}));
